/**
 * Default SweetAlert2 toast configuration.
 *
 * @type {Object}
 */
window.Toast = Swal.mixin({
    toast: true,
    timer: 6000,
    position: 'top-end',
    showConfirmButton: false,
    timerProgressBar: true,
    showCloseButton: true,
});

/**
 * Fire a SweetAlert2 toast.
 *
 * @param title {String}
 * @param text {String||null}
 * @param icon {String}
 * @returns void
 */
window.fireToast = (title, text, icon) => {
    Toast.fire({
        title: title,
        text: text ?? '',
        icon: icon,
    })
};

/**
 * Fire a success SweetAlert2 toast.
 *
 * @param {String} title
 * @param {String||null} text
 * @returns void
 */
window.fireSuccessToast = (title, text) => fireToast(title, text, 'success');

/**
 * Fire a warning SweetAlert2 toast.
 *
 * @param {String} title
 * @param {String||null} text
 * @returns void
 */
window.fireWarningToast = (title, text) => fireToast(title, text, 'warning');

/**
 * Fire a error SweetAlert2 toast.
 *
 * @param {String} title
 * @param {String||null} text
 * @returns void
 */
window.fireErrorToast = (title, text) => fireToast(title, text, 'error');

/**
 * Fire a question SweetAlert2 toast.
 *
 * @param {String} title
 * @param {String||null} text
 * @returns void
 */
window.fireQuestionToast = (title, text) => fireToast(title, text, 'question');

/**
 * Default SweetAlert2 modal configuration.
 *
 * @type {Object}
 */
window.Modal = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-default mr-2'
    },
    buttonsStyling: false
});

/**
 * Fire a confirmation SweetAlert2 modal.
 *
 * @param confirmedAction {Function||null}
 * @param title {String||null}
 * @param text {String||null}
 * @param icon {String}
 * @returns void
 */
window.fireModal = (confirmedAction, title, text, icon) => {
    Modal.fire({
        title: title ?? 'Souhaitez-vous vraiment continuer ?',
        text: text ?? "Cette action est irreversible.",
        icon: icon,
        confirmButtonText: Boolean(confirmedAction) ? 'Confirmer' : 'Continuer',
        showCancelButton: Boolean(confirmedAction),
        cancelButtonText: 'Annuler',
        reverseButtons: Boolean(confirmedAction),
    }).then((result) => {
        if (confirmedAction && result.isConfirmed) {
            confirmedAction();
        }
    })
};

/**
 * Fire a success SweetAlert2 modal.
 *
 * @param {String||null} title
 * @param {String||null} text
 * @returns void
 */
window.fireSuccessModal = (title, text) => fireModal(null, title, text, 'success');

/**
 * Fire a warning SweetAlert2 modal.
 *
 * @param {Function||null} confirmedAction
 * @param {String||null} title
 * @param {String||null} text
 * @returns void
 */
window.fireWarningModal = (confirmedAction = null, title = null, text = null) => fireModal(confirmedAction, title, text, 'warning');


/**
 * Fire a error SweetAlert2 modal.
 *
 * @param {Function||null} confirmedAction
 * @param {String||null} title
 * @param {String||null} text
 * @returns void
 */
window.fireErrorModal = (confirmedAction = null, title, text) => fireModal(confirmedAction, title, text, 'error');

/**
 * Fire a question SweetAlert2 modal.
 *
 * @param {Function||null} confirmedAction
 * @param {String||null} title
 * @param {String||null} text
 * @returns void
 */
window.fireQuestionModal = (confirmedAction = null, title, text) => fireModal(confirmedAction, title, text, 'question');
